import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 16,
};

const ProtectedAchievementNotice = ({ record }) => {
  if (!record) {
    return null;
  }

  return (
    <Paper style={{ padding: 24, marginTop: 8 }}>
      <div style={containerStyle}>
        <LockIcon color="action" />
        <div>
          <Typography variant="h6" component="h3">
            Backend-managed achievement
          </Typography>
          <Typography variant="body2" color="textSecondary">
            “{record.name}” is granted automatically in code. Please contact Engineering if you need
            to adjust it, or create a new achievement instead of editing/removing this one.
          </Typography>
        </div>
      </div>
    </Paper>
  );
};

export default ProtectedAchievementNotice;
